<template>
  <div class="ws-de-center-accred-comps">
    <ws-list-view class="ws-de-center-accred-comps__table is-table is-small"
                  :bordered="true"
                  :data="newData"
                  :header="true"
                  :detailed="false"
                  :columns="columns">
      <template slot-scope="props">
        <ws-list-view-item-column>
          <span v-text="props.row.number"></span>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <span>
            <strong>{{ props.row.competency.code }}</strong> {{ props.row.competency.name.display }}
            <!--<pre>{{ props.row }}</pre>-->
          </span>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <span v-text="props.row.complexity_level"></span>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <span v-text="props.row.workers"></span>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <ws-time-formatter :date="props.row.created_at" />
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <ws-accreditation :accred_comps="props.row" />
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth has-text-right">
            <ws-role-node :except="[ 'front_curator_institution', 'front_university', 'front_curator', 'front_rcc']">
              <button class="button is-text"
                      @click="editItem(props.row)"
                      :aria-label="$t('Редактировать')">
                <ws-icon
                        class="ws-button__icon"
                        name="edit"
                        color="#6D9AE8"
                        :fill="false"
                        width="14"
                        height="14"
                />
              </button>
              <ws-role-node :except="['front_dep', 'front_auditor', 'front_education_ministry', 'front_admin', 'front_rcc','front_curator']">
                <button class="button is-text"
                        :aria-label="$t('Удалить')"
                        @click="removeItem(props.row)">
                  <ws-icon
                          class="ws-button__icon"
                          name="trash"
                          color="#6D9AE8"
                          :fill="false"
                          width="14"
                          height="14"
                  />
                </button>
              </ws-role-node>
            </ws-role-node>

          </div>
        </ws-list-view-item-column>
      </template>
      <template slot="header" slot-scope="props">
        <strong>{{ props.column.label }}</strong>
      </template>
    </ws-list-view>
    <footer class="ws-de-center-accred-comps__footer">
      <ws-role-node :only="[]">
        <button class="ws-button button is-text" @click="addNewItem">
          <ws-icon
            class="ws-button__icon is-position-left"
            name="plus-circle"
            :title="$t('Запрос на аккредитацию')"
            color="#1c3b8d"
            width="20"
            height="20"
          />
          <strong class="ws-button__text has-text-primary" v-text="$t('Запрос на аккредитацию')"></strong>
        </button>
      </ws-role-node>
    </footer>
  </div>
</template>

<script>
import WsRequestAccredCompsForm from '@/components/de/de-center/modals/WsRequestAccredCompsForm'
import { mapActions } from 'vuex'
import WsAccreditation from '@/components/de/de-center/WsAccredidation'
import { isDeCenterAccredited } from '@/utils/isDeCenterAccreditated'
export default {
  name: 'WsDeCenterAccredCompsTable',
  components: { WsAccreditation },
  props: {
    deCenterGuid: {
      type: String
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      newData: [],
      columns: [
        {
          field: 'title',
          label: this.$t('№')
        },
        {
          field: 'code',
          label: this.$t('Профессия/специальность (ДЭ)')
        },
        {
          field: 'code',
          label: this.$t('Код')
        },
        {
          field: 'code',
          label: this.$t('Рабочие места')
        },
        {
          field: 'code',
          label: this.$t('Дата подачи')
        },
        {
          label: ''
        },
        {
          label: ''
        }
      ]
    }
  },
  watch: {
    data: {
      handler (data) {
        if (data) {
          this.newData = [...data]
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('de-centers', ['update']),
    editItem (item) {
      this.$buefy.modal.open({
        parent: this,
        component: WsRequestAccredCompsForm,
        hasModalCard: true,
        props: {
          guid: this.deCenterGuid,
          item
        },
        events: {
          added: event => {
            this.newData = event.accred_comps
          }
        },
        canCancel: false
      })
    },
    addNewItem () {
      this.$buefy.modal.open({
        parent: this,
        component: WsRequestAccredCompsForm,
        hasModalCard: true,
        canCancel: false,
        props: {
          guid: this.deCenterGuid
        },
        events: {
          added: event => {
            this.newData = event.accred_comps
          }
        }
      })
    },
    removeItem (item) {
      this.$buefy.dialog.confirm({
        title: this.$t(`Вы действительно хотите удалить аккредитацию «${item.number}»?`),
        cancelText: this.$t('Отмена'),
        confirmText: this.$t('Удалить'),
        type: 'is-danger',
        onConfirm: async () => {
          try {
            this.isRemovePending = true
            const deCenter = await this.update([ this.deCenterGuid, { delete: [item.guid] }, `/accred_comps` ])
            this.newData = deCenter.accred_comps
            this.$buefy.toast.open({
              message: this.$t(`Обследование № «${item.number}» была успешно удалена`),
              type: 'is-success'
            })
          } catch (e) {
            this.$buefy.toast.open({
              message: this.$t('Что-то пошло не так. Попробуйте еще раз'),
              type: 'is-danger'
            })
          } finally {
            this.isRemovePending = false
          }
        }
      })
    },
    isAcredentialled (item) {
      return isDeCenterAccredited(item)
    }
  }
}
</script>
